import { Kaggle } from "@kaggle/sdk";
import { NotebookActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";

import AcceleratorType = Kaggle.Sdk.Kernels.AcceleratorType;

export const accelerator = (
  state: AcceleratorType = AcceleratorType.NONE,
  action: NotebookAction
): AcceleratorType => {
  switch (action.type) {
    case NotebookActionKey.SET_DRAFT_SPEC:
      // TODO(cochamberlain): Map usage over to generic entities.
      return action.payload.draftSpec.accelerator;
    case NotebookActionKey.SET_IS_GPU_ENABLED:
      return action.payload.isEnabled
        ? AcceleratorType.GPU
        : AcceleratorType.NONE;
    case NotebookActionKey.SET_ACCELERATOR:
      return action.payload.accelerator;
    default:
      return state;
  }
};

export const showAcceleratorUnusedCallout = (
  state: boolean = false,
  action: NotebookAction
) => {
  switch (action.type) {
    case NotebookActionKey.SET_SHOW_ACCELERATOR_UNUSED_CALLOUT:
      return action.payload.show;
    default:
      return state;
  }
};
